<template>
  <div id="getlink" :class="{ open: open }">
    <div class="getcontent">
      <div class="head">
        <b>详情</b>
        <span class="close">
          <i class="ti-close" @click="close"></i>
        </span>
      </div>
      <div class="cont">
        <!-- <div class="pic">
          <img src />
        </div>-->
        <div class="pic" :style="preivewHeight" v-if="open">
          <component :is="previewer"></component>
        </div>
        <div class="form-horizontal">
          <div class="form-group">
            <label>文件名：</label>
            <div class="info">
              <p>
                {{ shareInfo.resource_name
                }}{{
                  shareInfo.resource_ext ? "." + shareInfo.resource_ext : ""
                }}
              </p>
            </div>
          </div>
          <div class="form-group">
            <label>文件大小：</label>
            <div class="info">
              <p>{{ shareInfo.resource_size | bytesToSize2 }}</p>
            </div>
          </div>
          <div class="form-group">
            <label>修改日期：</label>
            <div class="info">
              <p>{{ shareInfo.resource_last_updated_date }}</p>
            </div>
          </div>
          <div class="form-group">
            <label>创建人：</label>
            <div class="info">
              <p>{{ shareInfo.resource_creater_name }}</p>
            </div>
          </div>
        </div>
        <div class="form-horizontal">
          <div class="form-group">
            <h4>引用地址</h4>
          </div>
          <div class="form-group">
            <p>
              <b>方式一：直接引入文件</b>
            </p>
            <p>可直接将本文件链接嵌入您自己的网站直接访问文件资源</p>
            <div class="input-group">
              <input
                class="form-control"
                type="text"
                readonly
                :value="shareInfo.direct_url"
              />
              <div class="input-group-btn">
                <button
                  class="btn btn-primary"
                  type="button"
                  ref="copy1"
                  @click="copy1"
                >
                  {{ copyText1 }}
                </button>
              </div>
            </div>
            <p style="color: #006adf">
              如果文件设置了访问密码策略，使用该方式请求时，需在url中添加请求参数”?auth=md5(访问密码)”
            </p>
          </div>
          <div class="form-group">
            <p>
              <b>方式二：跳转到以下链接访问</b>
            </p>
            <p>通过本链接进入睿客网访问该文件信息</p>
            <div class="input-group">
              <input
                class="form-control"
                type="text"
                readonly
                :value="linkUrl"
              />
              <div class="input-group-btn">
                <button
                  class="btn btn-primary"
                  type="button"
                  ref="copy2"
                  @click="copy2"
                >
                  {{ copyText2 }}
                </button>
              </div>
            </div>
            <!-- <p style="color:#006adf;">使用该方式访问时，将忽略请求域的限制</p> -->
          </div>
          <div class="form-group">
            <p>
              <b>方式三：iframe嵌入</b>
            </p>
            <p>将下面的代码插入您的网页中即可访问该文件</p>
            <textarea
              class="form-control"
              readonly
              :value="iframeData"
            ></textarea>
            <a ref="copy3" @click="copy3">{{ copyText3 }}</a>
          </div>
        </div>
        <div class="form-horizontal">
          <div class="form-group">
            <h4>文件访问策略</h4>
            <span class="helpbox">
              <i class="ti-help-alt"></i>
              <div class="help">
                文件的访问策略，是依赖于发布包上设置的策略。同一个发布记录中的文件访问策略是一致的。修改发布策略，请在"已发布"列表中，选择一条发布记录，点击"编辑发布"。
              </div>
            </span>
          </div>
          <div class="form-group">
            <label>密码：</label>
            <div class="info">
              <p>
                {{
                  shareInfo.link_constraint &&
                  shareInfo.link_constraint.password
                    ? shareInfo.link_constraint.password
                    : ""
                }}
              </p>
            </div>
          </div>
          <div class="form-group">
            <label>有效期：</label>
            <div class="info">
              <p>
                {{
                  shareInfo.link_constraint && shareInfo.link_constraint.date
                    ? shareInfo.link_constraint.date
                    : ""
                }}
              </p>
            </div>
          </div>
          <div class="form-group">
            <label>允许访问IP：</label>
            <div class="info">
              <p>
                {{
                  shareInfo.link_constraint && shareInfo.link_constraint.ip
                    ? shareInfo.link_constraint.ip.toString()
                    : ""
                }}
              </p>
            </div>
          </div>
          <!-- <div class="form-group">
            <label>允许请求域：</label>
            <div class="info">
              <p>{{shareInfo.link_constraint && shareInfo.link_constraint.host ? shareInfo.link_constraint.host.toString() : '' }}</p>
            </div>
          </div>-->
        </div>
      </div>
    </div>
    <div class="bg" @click="close"></div>
  </div>
</template>

<script>
import { bytesToSize2 } from "@/utils/index";
export default {
  name: "TableSendDetail",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      preview_path: "",
      copyText1: "复制链接",
      copyText2: "复制链接",
      copyText3: "复制代码",
    };
  },
  created() {
    // console.log("初始化TableSendDetail");
  },
  filters: {
    bytesToSize2: bytesToSize2,
  },
  computed: {
    preivewHeight() {
      if (this.shareInfo.resource_ext) {
        return ["mp3", "wma"].indexOf(this.shareInfo.resource_ext) > -1
          ? "height:60px"
          : "";
      } else {
        return "";
      }
    },
    previewer() {
      return this.$store.state.drive.previewData.previewer;
    },
    iframeData() {
      if (
        this.share &&
        this.share.link_number &&
        this.shareInfo &&
        this.shareInfo.resource_number
      ) {
        let routeUrl = this.$router.resolve({
          name: "linkd",
          params: {
            link_number: this.share.link_number,
            resource_number: this.shareInfo.resource_number,
          },
        });
        return `<iframe frameborder="no" border="0" marginwidth="0" marginheight="0" src="${window.location.origin}${routeUrl.href}"></iframe>`;
      } else {
        return "";
      }
    },
    shareInfo() {
      return this.$store.state.drive.shareInfo;
    },
    share() {
      return this.$store.state.drive.share;
    },
    linkUrl() {
      if (this.share && this.share.link_number) {
        let routeUrl = this.$router.resolve({
          name: "sendlink",
          params: { link_number: this.share.link_number },
        });
        return window.location.origin + routeUrl.href;
      }
      return "";
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    copy1() {
      this.$copyText(this.shareInfo.direct_url, this.$refs.copy1)
        .then(() => {
          this.copyText1 = "已复制";
        })
        .catch(() => {
          this.copyText1 = "复制失败";
          alert("复制失败，建议您手动复制");
        });
      setTimeout(() => {
        this.copyText1 = "复制链接";
      }, 2000);
    },
    copy2() {
      this.$copyText(this.linkUrl, this.$refs.copy2)
        .then(() => {
          this.copyText2 = "已复制";
        })
        .catch(() => {
          this.copyText2 = "复制失败";
          alert("复制失败，建议您手动复制");
        });
      setTimeout(() => {
        this.copyText2 = "复制链接";
      }, 2000);
    },
    copy3() {
      this.$copyText(this.iframeData, this.$refs.copy3)
        .then(() => {
          this.copyText3 = "已复制";
        })
        .catch(() => {
          this.copyText3 = "复制失败";
          alert("复制失败，建议您手动复制");
        });
      setTimeout(() => {
        this.copyText3 = "复制代码";
      }, 2000);
    },
  },
  destroyed() {
    // console.log("组件TableSendDetail已销毁");
  },
};
</script>

<style scoped>
</style>